import {getProjectOverviewLocator} from '../../../../../../rest/locators'
import {getProjectBuildTypeFilter} from '../../../../../../types'

import type {FetcherOwnProps} from './BuildTypeLine.types'

const MIN_AMOUNT_OF_FINISHED_BUILDS = 50
const MULTIPLE_FACTOR_FOR_QUEUED_COUNT = 2
export const getBuildTypeLineLocator = (
  {buildTypeId, branch}: FetcherOwnProps,
  branchesCount: number,
) => {
  const finishedCount =
    branchesCount < MIN_AMOUNT_OF_FINISHED_BUILDS ? MIN_AMOUNT_OF_FINISHED_BUILDS : branchesCount
  const runningCount = finishedCount * MULTIPLE_FACTOR_FOR_QUEUED_COUNT
  const queuedCount = finishedCount * MULTIPLE_FACTOR_FOR_QUEUED_COUNT
  return getProjectOverviewLocator({
    runningCount,
    queuedCount,
    finishedCount,
    branch,
    projectBuildtype: getProjectBuildTypeFilter({
      buildTypeId,
    }),
  })
}
